<template lang="pug">
.list(v-if="list.length > 0")
    ol
        li(v-for="item in list")
            span.but( @click="clickItem(item)") {{item.name}}
            .right(v-if="item.hasNext")
                fa-icon(:icon="['fas', 'angle-right']")
</template>

<script>
export default {
  name: 'manageNavigator',
  emits: ['clickItem'],
  props: {
    list: {
      type: Array,
      required: true,
    },

  },
  methods: {
    clickItem(item) {
      this.$emit('clickItem', item);
    },
  },
};
</script>
<style lang="scss" scoped>
.list {
    display: flex;
    padding-bottom: 15px;
    align-items: flex-start;
}
ol {
    display: flex !important;
}
span {
  cursor: pointer;
}
.right {
  padding-left: 5px;
  padding-right: 5px;
}
li{
    display: flex;
    flex-wrap: column;
    align-items: flex-start;

}
</style>